import { Box, Typography, useTheme } from "@material-ui/core";
import React from "react";
import { ProductVariantType } from "../../../../../types/airgraft";
import deepEqual from "react-fast-compare";

type Props = {
  productVariant: ProductVariantType;
};

function ProductDetailsOilTable({ productVariant }: Props) {
  const theme = useTheme();
  const oilDetails = productVariant.variantDetail;
  const coaReport = oilDetails?.coaReport;

  if (!oilDetails || !coaReport) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      justifyContent="space-between"
      borderTop={`2px solid ${theme.palette.grey[400]}`}
      borderBottom={`2px solid ${theme.palette.grey[400]}`}
      textAlign="left"
      whiteSpace="nowrap"
    >
      {/* First row */}
      <Box display="flex" paddingY="5px">
        {/* Extraction type (oilType) */}
        <Box
          pr={1}
          flex={1}
          borderRight={`1px solid ${theme.palette.grey[400]}`}
          paddingY="2px"
        >
          <Typography variant="body1">{oilDetails.oilType}</Typography>
        </Box>

        {/* Sativa/Indica/Hybrid */}
        <Box
          flex={1}
          paddingX={1}
          borderRight={`1px solid ${theme.palette.grey[400]}`}
          paddingY="2px"
        >
          <Typography variant="body1">{oilDetails.plantSpecies}</Typography>
        </Box>

        {/* Weight 1g */}
        <Box paddingX={1} minWidth="50px" paddingY="2px">
          <Typography variant="body1">{coaReport.weightText}</Typography>
        </Box>
      </Box>

      {/* Second row */}
      <Box
        display="flex"
        paddingY="8px"
        borderTop={`1px solid ${theme.palette.grey[400]}`}
      >
        {/* THC */}
        <Box pr={1} flex={1}>
          <Typography variant="body1">
            THC: {coaReport.thcTotalPercentText}
          </Typography>
        </Box>

        {/* CBD */}
        <Box paddingX={1} flex={1}>
          <Typography variant="body1">
            CBD: {coaReport.cbdTotalPercentText}
          </Typography>
        </Box>

        {/* TERPS */}
        <Box paddingX={1} textAlign="right">
          <Typography variant="body1">
            TERPS: {coaReport.terpenesTotalPercentText}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(ProductDetailsOilTable, deepEqual);
